
// SAVVY Theme JS

// ── Cart Drawer ──────────────────────────────────────────────
class CartDrawer {
  constructor() {
    this.overlay = document.querySelector('.cart-overlay');
    this.drawer = document.querySelector('.cart-drawer');
    this.closeBtn = document.querySelector('.cart-close-btn');
    this.openBtns = document.querySelectorAll('[data-cart-open]');
    if (!this.overlay) return;
    this.openBtns.forEach(b => b.addEventListener('click', () => this.open()));
    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', e => { if (e.target === this.overlay) this.close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
  }
  open() {
    this.overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    this.refreshCart();
  }
  close() {
    this.overlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  async refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
    } catch(e) {}
  }
  render(cart) {
    // Update count badges
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    // Update shipping progress
    const threshold = 5000; // $50 in cents
    const pct = Math.min(cart.total_price / threshold * 100, 100);
    const fill = document.querySelector('.cart-progress__fill');
    const msg = document.querySelector('.cart-progress__msg');
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      msg.textContent = cart.total_price >= threshold
        ? '✓ Free shipping unlocked'
        : '$' + ((threshold - cart.total_price) / 100).toFixed(0) + ' away from free shipping';
    }
    // Render items
    const itemsEl = document.querySelector('.cart-items');
    if (!itemsEl) return;
    if (cart.items.length === 0) {
      itemsEl.innerHTML = '<div style="padding:48px 0;text-align:center;font-family:var(--font-body);color:var(--c-mute);font-size:14px;">Your bag is quiet. Let\'s fix that.</div>';
    } else {
      itemsEl.innerHTML = cart.items.map(item => `
        <div class="cart-item">
          <img class="cart-item__img" src="${item.image || ''}" alt="${item.title}">
          <div style="flex:1">
            <div class="cart-item__name">${item.product_title}</div>
            <div class="cart-item__meta">${item.variant_title || 'One-size'} &middot; Qty ${item.quantity}</div>
          </div>
          <div style="font-family:var(--font-mono);font-size:12px">$${(item.final_price/100).toFixed(2)}</div>
          <button onclick="CartActions.remove(${item.id})" style="background:transparent;border:none;color:var(--c-mute);font-size:16px;cursor:pointer">&times;</button>
        </div>
      `).join('');
    }
    // Subtotal
    const sub = document.querySelector('.cart-subtotal__val');
    if (sub) sub.textContent = '$' + (cart.total_price / 100).toFixed(2);
  }
}

// ── Cart Actions ─────────────────────────────────────────────
const CartActions = {
  async add(variantId, qty = 1, properties = {}) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty, properties }),
    });
    const data = await res.json();
    window.cartDrawer?.open();
    return data;
  },
  async remove(lineItemId) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItemId, quantity: 0 }),
    });
    window.cartDrawer?.refreshCart();
  },
  async update(lineItemId, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItemId, quantity: qty }),
    });
    window.cartDrawer?.refreshCart();
  },
};

// ── Mobile Menu ──────────────────────────────────────────────
class MobileMenu {
  constructor() {
    this.overlay = document.querySelector('.mobile-menu-overlay');
    this.openBtn = document.querySelector('.mobile-hamburger');
    this.closeBtn = document.querySelector('.mobile-menu__close');
    if (!this.overlay) return;
    this.openBtn?.addEventListener('click', () => this.open());
    this.closeBtn?.addEventListener('click', () => this.close());
    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
  }
  open() { this.overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
  close() { this.overlay.classList.remove('open'); document.body.style.overflow = ''; }
}

// ── Tabs ─────────────────────────────────────────────────────
document.querySelectorAll('.tabs').forEach(tabsEl => {
  tabsEl.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      tabsEl.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const panel = document.querySelector('[data-tab-panel="' + target + '"]');
      document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
      panel?.classList.add('active');
    });
  });
});

// ── Size Buttons ─────────────────────────────────────────────
document.querySelectorAll('.size-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const group = btn.closest('.size-picker');
    group?.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    // Update variant select
    const size = btn.dataset.size;
    const variantSelect = document.querySelector('[data-variant-select]');
    if (variantSelect) {
      const opt = [...variantSelect.options].find(o => o.text.trim() === size);
      if (opt) { variantSelect.value = opt.value; variantSelect.dispatchEvent(new Event('change')); }
    }
  });
});

// ── Variant selector ─────────────────────────────────────────
const variantSelect = document.querySelector('[data-variant-select]');
const addToCartBtn = document.querySelector('[data-atc-btn]');
if (variantSelect && addToCartBtn) {
  variantSelect.addEventListener('change', () => {
    const price = variantSelect.selectedOptions[0]?.dataset.price;
    if (!price) return;
    const formatted = '$' + (parseInt(price) / 100).toFixed(2);
    const priceEl = document.querySelector('[data-product-price]');
    if (priceEl) priceEl.textContent = formatted;
    const atcPrice = document.querySelector('[data-atc-price]');
    if (atcPrice) atcPrice.textContent = formatted;
  });
}

// ── Add to cart button ────────────────────────────────────────
document.querySelector('[data-atc-form]')?.addEventListener('submit', async (e) => {
  e.preventDefault();
  const form = e.target;
  const variantId = form.querySelector('[data-variant-select]')?.value || form.querySelector('input[name="id"]')?.value;
  const qty = parseInt(form.querySelector('[data-qty]')?.value || '1');
  if (!variantId) return;
  const btn = form.querySelector('[data-atc-btn]');
  const btnInner = btn.innerHTML;
  btn.textContent = 'Adding...';
  btn.disabled = true;
  await CartActions.add(variantId, qty);
  btn.textContent = 'Added!';
  setTimeout(() => { btn.innerHTML = btnInner; btn.disabled = false; }, 1500);
});

// ── Qty stepper ───────────────────────────────────────────────
document.querySelectorAll('.qty-stepper').forEach(stepper => {
  const numEl = stepper.querySelector('.qty-num');
  stepper.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      let v = parseInt(numEl.textContent);
      v = btn.dataset.dir === 'up' ? v + 1 : Math.max(1, v - 1);
      numEl.textContent = v;
      const qtyInput = document.querySelector('[data-qty]');
      if (qtyInput) qtyInput.value = v;
    });
  });
});

// ── Media gallery ─────────────────────────────────────────────
document.querySelectorAll('.product-media__thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    document.querySelectorAll('.product-media__thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    const main = document.querySelector('.product-media__main-img');
    if (main) main.src = thumb.dataset.src;
  });
});

// ── Hand photo upload ─────────────────────────────────────────
const uploadCircle = document.querySelector('.upload-circle');
const uploadInput = document.querySelector('.upload-input');
if (uploadCircle && uploadInput) {
  uploadCircle.addEventListener('click', () => uploadInput.click());
  uploadInput.addEventListener('change', e => {
    const file = e.target.files?.[0];
    if (!file) return;
    const url = URL.createObjectURL(file);
    const img = uploadCircle.querySelector('img') || document.createElement('img');
    img.src = url;
    if (!img.parentNode) uploadCircle.appendChild(img);
    uploadCircle.querySelector('.upload-circle__placeholder')?.remove();
  });
}

// ── Password page form ────────────────────────────────────────
document.querySelector('.password-form')?.addEventListener('submit', async (e) => {
  e.preventDefault();
  const email = e.target.querySelector('input[type="email"]').value;
  const btn = e.target.querySelector('button[type="submit"]');
  btn.textContent = 'Joining...';
  // Shopify newsletter subscribe
  try {
    await fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({ form_type: 'customer', utf8: '✓', 'contact[email]': email, 'contact[tags]': 'newsletter,pre-launch' }),
    });
    btn.textContent = "You're in ✓";
    e.target.querySelector('input[type="email"]').value = '';
  } catch(err) {
    btn.textContent = 'Join the list →';
  }
});

// ── Init ─────────────────────────────────────────────────────
window.cartDrawer = new CartDrawer();
window.CartActions = CartActions;
window.mobileMenu = new MobileMenu();

// ── Quick Add ────────────────────────────────────────────────
document.addEventListener('click', async function(e) {
  const btn = e.target.closest('.product-card__quick-add');
  if (!btn || btn.disabled) return;
  const variantId = btn.dataset.variantId;
  if (!variantId) return;
  const original = btn.textContent;
  btn.textContent = '...';
  btn.disabled = true;
  try {
    await CartActions.add(variantId);
    window.cartDrawer?.refreshCart();
  } catch(err) {
    console.error('Quick add failed', err);
  } finally {
    btn.textContent = original;
    btn.disabled = false;
  }
});
